import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  HostListener
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import {CalendarEvent} from './calendar-event.model';
import {MatIcon} from '@angular/material/icon';
import html2canvas from 'html2canvas'; // Import html2canvas
import {
  convert_to_find_day,
  get_infos,
  getEventsForColumn,
  shorter,
  string_sorter_for_column
} from '../../main';
import {context_menu_enabled} from '../../env';
import {Tuto} from '../tuto/tuto';


@Component({
  selector: 'app-flexible-calendar',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, FormsModule, MatIcon],
  templateUrl: './flexible-calendar.component.html',
  styleUrls: ['./flexible-calendar.component.scss']
})
export class FlexibleCalendarComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() columnHeaderName: string[] = ["prop_1"]
  @Input() events: CalendarEvent[] = [];
  @Input() startTime: number = 8;
  @Input() endTime: number = 20;
  @Input() isMobile=false;
  @Input() show_periode=false;
  @Input() timeSlotInterval: number = 30;
  @Input() rowHeightPx: number = 50;
  @Input() all_headers:string[]=[]
  @Input() eventDisplayMask: string = "{titre} - {group}"; // New input for the mask
  @Input() eventDisplayInfoBulle: string = "{titre} - {group}"; // New input for the mask
  @Output() fire_open= new EventEmitter<any>();
  @Output() fire_entete= new EventEmitter<String>();
  @Output() get_capture= new EventEmitter<String>();
  @Output() fire_context_menu= new EventEmitter<{event: CalendarEvent, action: string}>();

  columnHeaders:string[]=[]
  supColumnHeaders:string[]=[]
  timeSlots: string[] = [];
  totalSlots: number = 0;
  containerWidth: number | undefined;
  containerHeight: number | undefined;
  private initialContainerWidth: number = 0
  private initialContainerHeight: number = 0

  // Context menu state
  contextMenuVisible: boolean = false;
  contextMenuX: number = 0;
  contextMenuY: number = 0;
  selectedEventForContextMenu: CalendarEvent | null = null;

  protected readonly convert_to_find_day = convert_to_find_day;
  protected readonly get_infos = get_infos;
  protected readonly shorter = shorter;
  protected readonly getEventsForColumn = getEventsForColumn;


  private eventStyles: Map<CalendarEvent, {
    top: string, height: string, left: string, width: string }> = new Map();
  private handle: number=0
  private hResize: number=0;


  constructor(private el: ElementRef) {}


  ngOnInit(): void {
    this.generateTimeSlots();
  }



  ngAfterViewInit() {
    // Observe the parent element to set the initial width
    new ResizeObserver(entries => {
        if (entries[0]) {
            // clearTimeout(this.hResize)
            // this.hResize=setTimeout(()=>{
              this.initialContainerWidth = entries[0].contentRect.width;
              if (this.containerWidth === undefined) {this.containerWidth = this.initialContainerWidth;}
              if (this.containerHeight === undefined) {this.containerHeight = this.initialContainerHeight;}
              this.onResize();
            // },200)
        }
    }).observe(this.el.nativeElement.parentElement);
  }

  onResize() {
      this.generateTimeSlots();
      this.recalculateLayout();
  }


  ngOnChanges(changes: SimpleChanges): void {
    let shouldRecalculate = false;

    if (changes['startTime'] || changes['endTime'] || changes['timeSlotInterval']) {
      this.generateTimeSlots();
      shouldRecalculate = true;
    }

    if (changes['columnHeaderName'] || changes['all_headers']) {
      if (this.all_headers.length == 0) {
        this.columnHeaders = []
        for (let event of this.events) {
          let vals = ""
          for (let colHeader of this.columnHeaderName) {
            if (colHeader)
              vals = vals + event.props[colHeader] + "-"
          }
          vals = vals.slice(0, -1)
          if (this.columnHeaders.indexOf(vals) == -1) this.columnHeaders.push(vals)
        }
      } else {
        this.columnHeaders=this.all_headers
      }

      this.supColumnHeaders=[]

      for (let it of this.columnHeaders) {
          if (this.supColumnHeaders.indexOf(it.split("-")[0]) == -1) {
            this.supColumnHeaders.push(it.split("-")[0])
          }
      }

      this.captureAsPng();

    }

    if (changes['events']) {
      shouldRecalculate = true;
    } else if (changes['columnHeaders'] || changes['rowHeightPx']) {
      shouldRecalculate = true;
    }

    if(shouldRecalculate){
      this.recalculateLayout()
      this.evaluate_min_column_width()
    }
  }




  evaluate_min_column_width(limit=100) {
    if(this.columnHeaders.length>0){
      const rc=this.initialContainerWidth/this.columnHeaders.length;
      if(rc<limit || (this.containerWidth && this.containerWidth>8000)) {
        //this.containerWidth = limit * this.columnHeaders.length;
      }
    }
  }



  private recalculateLayout(): void {
    this.eventStyles.clear();
    if (!this.events) return;

    // Filter out empty/null column headers and get the effective count
    const validColumnHeaders = this.columnHeaderName.filter(col => col && col.length > 0);
    const validColumnCount = validColumnHeaders.length;

    this.columnHeaders.forEach(header => {
      let colEvents: any[] = []

      for (let e of this.events){
        let sc=0
        let i=0
        for(let col of validColumnHeaders){
          if(convert_to_find_day(e.props[col])==header.split("-")[i])sc=sc+1
          i=i+1
        }
        if(sc==validColumnCount){
          colEvents.push(e)
        }
      }

      this.layoutEventsForColumn(colEvents);
    });
  }

  private generateTimeSlots(): void {
    this.timeSlots = [];

    // 1. Enforce a safe, minimum interval to prevent infinite loops
    if (window.innerHeight < 800) {
      this.timeSlotInterval = 60;
    }
    const interval = this.timeSlotInterval > 0 ? this.timeSlotInterval : 30;

    // 2. Convert boundaries to minutes
    const startMinutes = this.startTime * 60;
    const endMinutes = this.endTime * 60;
    const totalMinutes = Math.max(0, endMinutes - startMinutes);

    // 3. Generate slots precisely matching the loop boundaries
    for (let m = startMinutes; m <= endMinutes; m += interval) {
      const hours = Math.floor(m / 60);
      const minutes = m % 60;
      this.timeSlots.push(`${this.formatTime(hours)}:${this.formatTime(minutes)}`);
    }

    // 4. Align total slots accurately with the generated array length
    this.totalSlots = this.timeSlots.length;

    // 5. Calculate row height safely to prevent division-by-zero layout crashes
    if (this.totalSlots > 0) {
      const availableHeight = Math.max(0, window.innerHeight - 220);
      this.rowHeightPx = availableHeight / (this.totalSlots-1);
    } else {
      this.rowHeightPx = 0;
    }
  }


  private formatTime(unit: number): string {
    return unit < 10 ? '0' + unit : '' + unit;
  }




  calculateEventStyle(event: CalendarEvent): { top: string, height: string, left: string, width: string } {
    return this.eventStyles.get(event) || { ...this.calculateBaseStyle(event), left: '0%', width: '100%' };
  }

  private getMinutesFromStartOfDay(date: Date): number {
    return date.getHours() * 60 + date.getMinutes();
  }



  private calculateBaseStyle(event: CalendarEvent): { top: string, height: string } {
    const startMinutes = this.getMinutesFromStartOfDay(event.startTime);
    const endMinutes = this.getMinutesFromStartOfDay(event.endTime);
    const durationMinutes = endMinutes - startMinutes;

    const calendarStartMinutes = this.startTime * 60;

    const offsetMinutes = startMinutes - calendarStartMinutes;
    const topPx = (offsetMinutes / this.timeSlotInterval) * this.rowHeightPx;
    const heightPx = (durationMinutes / this.timeSlotInterval) * this.rowHeightPx;

    return {
      top: `${topPx}px`,
      height: `${heightPx}px`
    };
  }



  private layoutEventsForColumn(events: CalendarEvent[]): void {
    if (events.length === 0) return;

    const sortedEvents = [...events].sort((a, b) => {
      return this.getMinutesFromStartOfDay(a.startTime) - this.getMinutesFromStartOfDay(b.startTime);
    });

    const columns: CalendarEvent[][] = [];

    for (const event of sortedEvents) {
      let placed = false;
      for (let i = 0; i < columns.length; i++) {
        const col = columns[i];
        const lastEvent = col[col.length - 1];
        if (!this.doEventsOverlap(lastEvent, event)) {
          col.push(event);
          placed = true;
          break;
        }
      }
      if (!placed) {
        columns.push([event]);
      }
    }

    const totalCols = columns.length;
    const widthPercent = 100 / totalCols;

    columns.forEach((col, colIndex) => {
      col.forEach(event => {
        const base = this.calculateBaseStyle(event);
        this.eventStyles.set(event, {
          ...base,
          left: `${colIndex * widthPercent}%`,
          width: `${widthPercent}%`
        });
      });
    })

  }



  private doEventsOverlap(e1: CalendarEvent, e2: CalendarEvent): boolean {
    const start1 = this.getMinutesFromStartOfDay(e1.startTime);
    const end1 = this.getMinutesFromStartOfDay(e1.endTime);
    const start2 = this.getMinutesFromStartOfDay(e2.startTime);
    const end2 = this.getMinutesFromStartOfDay(e2.endTime);

    return Math.max(start1, start2) < Math.min(end1, end2);
  }


  protected readonly string_sorter = string_sorter_for_column;


  zoom_entete(delta:number){
    this.rowHeightPx=this.rowHeightPx+delta
  }


  onWheel(event: any) {
    event.preventDefault();
    if (event.deltaY < 0) {
      this.zoom_entete(Math.min(this.rowHeightPx + 5*(event.shiftKey ? 2 : 1), -5))
    } else {
      this.zoom_entete(Math.max(this.rowHeightPx - 5*(event.shiftKey ? 2 : 1), 5))
    }
    this.recalculateLayout();
  }


  onHeaderWheel(event: WheelEvent) {
    event.preventDefault()
    const currentWidth = this.containerWidth || this.initialContainerWidth;
    if (event.deltaY < 0) {
      this.containerWidth = currentWidth + 50*(event.ctrlKey ? 4 : 1); // Increase width
    } else {
      this.containerWidth = Math.max(currentWidth - 50*(event.ctrlKey ? 4 : 1), this.initialContainerWidth);
    }
  }


  onPinch(evt:any) {
    evt.preventDefault()
  }


  captureAsPng(): void {
    // Un léger délai permet à Angular de terminer le rendu des div d'événements
    console.log("Appel de capture")
    clearTimeout(this.handle);
    this.handle=setTimeout(() => {
      const calendarContainer = this.el.nativeElement.querySelector('.calendar-container');

      if (calendarContainer) {
        html2canvas(calendarContainer, { // Capture le div.calendar-container
          useCORS: true, // Important si vous avez des images ou des ressources externes
          logging: true, // Désactive les logs de html2canvas
          scale: 3, // Augmente la résolution de la capture pour une meilleure qualité
          height: calendarContainer.scrollHeight, // Capture toute la hauteur défilable
          width: calendarContainer.scrollWidth,   // Capture toute la largeur défilable
        }).then(canvas => {
          const imgData = canvas.toDataURL('image/png', 1.0);
          this.get_capture.emit(imgData);
        }).catch(error => {
          console.error('[ERROR] html2canvas failed:', error.message);
          // Fallback: emit empty data to prevent UI freeze
          this.get_capture.emit('');
        });
      } else {
        console.error('Calendar container not found for capture.');
      }
    }, 400); // Délai de 200ms
  }

  public mouse_event:any=null
  open_event(event: CalendarEvent) {
    this.fire_open.emit({event:event,mouse:this.mouse_event})
  }

  protected keyboard_evt($event: any) {
    this.mouse_event=$event
  }



  // Context menu methods
  onContextMenu(event: MouseEvent, calEvent: CalendarEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.mouse_event = event;
    this.selectedEventForContextMenu = calEvent;
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.contextMenuVisible = true;
  }



  hideContextMenu(): void {
    this.contextMenuVisible = false;
    this.selectedEventForContextMenu = null;
  }



  onContextMenuAction(action: string): void {
    if (this.selectedEventForContextMenu) {
      this.fire_context_menu.emit({
        event: this.selectedEventForContextMenu,
        action: action
      });
    }
    this.hideContextMenu();
  }



  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.contextMenuVisible) {
      this.hideContextMenu();
    }
  }



  protected readonly context_menu_enabled = context_menu_enabled;
}
